// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  firebase: {
    apiKey: "AIzaSyAYSU90V1qXd7yYf7qIDfes-dekdnbu3BE",
    authDomain: "capital-7c93a.firebaseapp.com",
    databaseURL: "https://capital-7c93a.firebaseio.com",
    projectId: "capital-7c93a",
    storageBucket: "capital-7c93a.appspot.com",
    messagingSenderId: "155370542502",
    appId: "1:155370542502:web:7581ddffc393baff"
  }
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
